<template>
    <el-upload
            ref="upload"
            :action="url"
            class="avatar-uploader"
            :multiple="multiple"
            :file-list="fileList"
            :before-upload="beforeUploadHandle"
            :http-request="uploadOk"
            :on-success="successHandle"
            :auto-upload="true"
            :show-file-list="false"
    >
        <img v-if="imgsrc" :src="imgsrc" class="avatar">
        <i v-else :style="{backgroundImage:'url('+ bgImg +')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
        <div slot="tip" class="el-upload__tip" style="line-height: 20px;margin-top: 0;">{{tips}}</div>
    </el-upload>

</template>

<script>
import Cookies from 'js-cookie'

export default {
  props: {
    tips: {
      type: String,
      default: '',
      required: false
    },
    bgImg: {
      type: String,
      default: '',
      required: false
    }
  },
  data () {
    return {
      multiple: false,
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      fileList: [{
        id: '',
        fileName: '',
        fileType: '',
        size: '',
        url: ''
      }],
      imgsrc: ''
    }
  },
  methods: {
    init () {
      this.visible = true
      this.url = `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?token=${Cookies.get('token')}`
      this.num = 0
      this.fileList = []
    },
    // 上传之前
    beforeUploadHandle (file) {
      if (this.uploadType && this.uploadType.length > 0) {
        if (this.uploadType.indexOf(file.type) === -1) {
          this.$message.error(this.$t('upload.tip', { 'format': 'jpg、png、gif' }))
          return false
        }
      }
				 if (file.size / 1024 / 1024 > 30) { this.$message.error('文件太大，只能上传30MB以内的文件'); return false }
    },
    // 上传操作
    uploadOk (val) {
      let fd = new FormData()
      fd.append('file', val.file)
      fd.append('uploadFile', val.file)
      this.$http.post(this.uploadUrl, fd).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.successHandle(res.data)
      }).catch(() => {
      })
    },
    // 上传成功
    successHandle (data, file) {
      this.imgsrc = data.docPath
      this.filePath.push(this.imgsrc)
      this.filePath.push(this.index)
      if (data.num != undefined && data.num != null && data.num != '') {
        this.filePath.push(data.num)
      }
      this.num--
      if (this.num === 0) {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit('change', this.filePath)
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9 !important;
        border-radius: 6px;
        cursor: pointer !important;
        position: relative;
        overflow: hidden
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 300px;
        height: 178px;
        line-height: 178px !important;
        text-align: center;
    }

    .avatar {
        width: 300px;
        height: 178px;
        display: block;
    }

    @media screen and (max-width: 1550px) {
        .avatar {
            width: 200px;
            height: 100px;
            display: block;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 250px;
            height: 150px;
            line-height: 150px !important;
            text-align: center;
        }
    }

    @media screen and (max-width: 1280px) {
        .avatar {
            width: 220px;
            height: 140px;
            display: block;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 220px;
            height: 140px;
            line-height: 140px !important;
            text-align: center;
        }
    }
</style>
